<template>
	<page>
		<module>
			<view-list
                ref="view"
                work-type="39"
                :view-config="saasInfo.viewmanage"
            >
				<template #search>
					<m-search ref="search">
						<m-search-item label="客户名称">
							<c-input name="name"></c-input>
						</m-search-item>
						<m-search-item label="联系电话">
							<c-input name="phone"></c-input>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" prepend-icon="tf-add" @click="editWarehouse()">新建回收质检仓</c-button>
				</template>

                <template #is_enable="{data}">
                    <c-switch v-model="data.is_enable" :state-value="[1, 0]" :state-text="['启用','禁用']" @beforeChange="toggleEnable(arguments[0], arguments[1], data)"></c-switch>
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="140"
				>
					<template #default="{data}">
						<c-table-button icon="tf-edit" @click="editWarehouse(data)">编辑</c-table-button>
						<c-table-button icon="tf-trash" color="red" @click="deleteWarehouse(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>

            <address-edit-dialog ref="addressEdit" @success="$refs.view.update()"></address-edit-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import addressEditDialog from './address_edit_dialog.vue'

	export default {
		name: 'qualityWarehouseList',

		components: {
			addressEditDialog
		},

		computed: {
			...mapState(['saasInfo'])
		},

        methods: {
			editWarehouse(data) {
				this.$refs.addressEdit.open(data, 3);
			},

			deleteWarehouse(data) {
				this.$confirm({
					message: '确定删除该质检仓吗？',
					resolve: () => {
						this.request({
							url: '/sys_saas/address/delete',
							data: {id: data.id, address_type: 3},
							loading: true,
							success: (res, msg) => {
								this.$message({message: '删除成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			toggleEnable(state, next, data) {
				this.request({
					url: '/sys_saas/address/setEnable',
					data: {
						id: data.id,
						address_type: 3,
						is_enable: state ? 0 : 1
					},
					success: (res, msg) => {
						this.$message({message: '设置成功', type: 'success'});
						next();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
